import { RemixiconComponentType } from '@remixicon/react';
import { ComponentProps, forwardRef } from 'react';
import { cn } from '~/helpers/tw';

interface IconProps extends ComponentProps<RemixiconComponentType> {
    type?: 'info' | 'warning' | 'error' | 'success';
    size: number;
    component: RemixiconComponentType;
    disabled?: boolean;
}

const Icon = forwardRef<SVGSVGElement, IconProps>(
    (
        {
            component: Component,
            size,
            type,
            className,
            disabled = false,
            ...props
        },
        ref
    ) => (
        <Component
            {...props}
            size={size}
            ref={ref}
            className={cn(
                {
                    'fill-red-600 dark:fill-red-400': type === 'error',
                    'fill-red-600/40 dark:fill-red-400/50':
                        type === 'error' && disabled,
                    'fill-yellow-700 dark:fill-yellow-800': type === 'warning',
                    'fill-yellow-700/50 dark:fill-yellow-800/50':
                        type === 'warning' && disabled,
                    'fill-primary dark:fill-blue-300': type === 'info',
                    'fill-primary/40 dark:fill-blue-300/50':
                        type === 'info' && disabled,
                    'fill-green-600 dark:fill-green-500': type === 'success',
                    'fill-green-600/50 dark:fill-green-500/50':
                        type === 'success' && disabled,
                },
                className
            )}
        />
    )
);

Icon.displayName = 'Icon';

export default Icon;
